import React from 'react';

// import store from '../../store/store';
// import { toggleAnalysis } from '../../reducers/mapview/actions';

import { text } from '../../config/staticText.config';

import './AnalyzeInstructions.scss';

const AnalyzeInstructions = () => (
  <div className="analyze-instructions-container">
    <div className="analyze-instructions-title">{text.instructionTitle}</div>
    <div className="analyze-instructions-text">{text.firstInstruction}</div>
    <div className="analyze-instructions-text">{text.instructionBreak}</div>
    <div className="analyze-instructions-text">{text.secondInstruction}</div>
    {/* <div className="polygon-image" /> */}
     {/*<div
      className="start-drawing-button button"
      onClick={() => store.dispatch(toggleAnalysis(true))}
    >
      {text.instructionButton}
    </div> */}
  </div>
);

export default AnalyzeInstructions;
